"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeMaxLength = exports.getFilteredEvents = exports.getFilteredNotifications = exports.getFilteredIssueOrPullRequests = exports.columnHasAnyFilter = exports.itemPassesStringSearchFilter = exports.itemPassesOwnerOrRepoFilter = exports.getOwnerAndRepoFormattedFilter = exports.getFilterCountMetadata = exports.itemPassesFilterRecord = exports.filterRecordWithThisValueCount = exports.filterRecordHasAnyForcedValue = void 0;
const lodash_1 = __importDefault(require("lodash"));
const utils_1 = require("../utils");
const github_1 = require("./github");
const events_1 = require("./github/events");
const shared_1 = require("./shared");
const filterRecordHasAnyForcedValue = (filtersRecord) => {
    if (!filtersRecord)
        return false;
    return Object.values(filtersRecord).some(value => typeof value === 'boolean');
};
exports.filterRecordHasAnyForcedValue = filterRecordHasAnyForcedValue;
const filterRecordWithThisValueCount = (filtersRecord, valueToCheck) => {
    if (!filtersRecord)
        return 0;
    return Object.values(filtersRecord).reduce((total, item) => total + (item === valueToCheck ? 1 : 0), 0);
};
exports.filterRecordWithThisValueCount = filterRecordWithThisValueCount;
function itemPassesFilterRecord(filtersRecord, value, defaultValue) {
    if (!(filtersRecord && value))
        return defaultValue;
    const hasForcedFilter = exports.filterRecordHasAnyForcedValue(filtersRecord);
    if (!hasForcedFilter)
        return defaultValue;
    const isFilterStrict = hasForcedFilter &&
        exports.filterRecordWithThisValueCount(filtersRecord, defaultValue);
    return filtersRecord[value] === !defaultValue ||
        (filtersRecord[value] !== defaultValue && isFilterStrict)
        ? !defaultValue
        : defaultValue;
}
exports.itemPassesFilterRecord = itemPassesFilterRecord;
function getFilterCountMetadata(filtersRecord, totalCount, defaultValue) {
    if (!filtersRecord)
        return { checked: 0, unchecked: 0, total: totalCount };
    const keys = Object.keys(filtersRecord);
    const hasForcedFilter = exports.filterRecordHasAnyForcedValue(filtersRecord);
    if (!hasForcedFilter) {
        return {
            checked: defaultValue ? totalCount : 0,
            unchecked: !defaultValue ? totalCount : 0,
            total: totalCount,
        };
    }
    const isFilterStrict = hasForcedFilter &&
        exports.filterRecordWithThisValueCount(filtersRecord, defaultValue);
    if (isFilterStrict) {
        return keys.reduce((result, key) => {
            const checked = filtersRecord[key] === defaultValue;
            return {
                ...result,
                checked: checked ? result.checked + 1 : result.checked,
                unchecked: !checked ? result.unchecked + 1 : result.unchecked,
            };
        }, { checked: 0, unchecked: 0, total: totalCount });
    }
    return keys.reduce((result, key) => {
        const checked = filtersRecord[key] === !defaultValue ? !defaultValue : defaultValue;
        return {
            ...result,
            checked: checked ? result.checked : result.checked - 1,
            unchecked: !checked ? result.unchecked : result.unchecked - 1,
        };
    }, { checked: totalCount, unchecked: totalCount, total: totalCount });
}
exports.getFilterCountMetadata = getFilterCountMetadata;
function getOwnerAndRepoFormattedFilter(filters) {
    const ownerFiltersWithRepos = (filters && filters.owners) || {};
    const ownerFilters = lodash_1.default.mapValues(ownerFiltersWithRepos, obj => obj && obj.value);
    const repoFilters = {};
    const allExistingOwners = Object.keys(ownerFiltersWithRepos);
    if (ownerFiltersWithRepos) {
        allExistingOwners.forEach(owner => {
            if (!(ownerFiltersWithRepos[owner] && ownerFiltersWithRepos[owner].repos))
                return;
            Object.entries((ownerFiltersWithRepos[owner] && ownerFiltersWithRepos[owner].repos) ||
                {}).forEach(([repo, value]) => {
                const repoFullName = `${owner}/${repo}`.toLowerCase();
                repoFilters[repoFullName] = value;
            });
        });
    }
    const ownerFilterIsStrict = !!(ownerFilters && exports.filterRecordWithThisValueCount(ownerFilters, true));
    const repoFilterIsStrict = !!(repoFilters && exports.filterRecordWithThisValueCount(repoFilters, true));
    const allForcedRepos = lodash_1.default.sortBy(Object.keys(repoFilters)
        .filter(repoFullName => typeof repoFilters[repoFullName] === 'boolean')
        .map(repoFullName => repoFullName.toLowerCase()));
    const allForcedOwners = lodash_1.default.sortBy(allExistingOwners
        .filter(ownerFilterWithRepo => !!ownerFiltersWithRepos[ownerFilterWithRepo] &&
        (typeof ownerFiltersWithRepos[ownerFilterWithRepo].value ===
            'boolean' ||
            exports.filterRecordHasAnyForcedValue(ownerFiltersWithRepos[ownerFilterWithRepo].repos)))
        .map(owner => owner.toLowerCase()));
    const allIncludedRepos = lodash_1.default.sortBy(Object.keys(repoFilters)
        .filter(repoFullName => repoFilters[repoFullName] === true)
        .map(repoFullName => repoFullName.toLowerCase()));
    const allIncludedOwners = lodash_1.default.sortBy(allExistingOwners
        .filter(ownerFilterWithRepo => !!ownerFiltersWithRepos[ownerFilterWithRepo] &&
        (ownerFiltersWithRepos[ownerFilterWithRepo].value === true ||
            exports.filterRecordWithThisValueCount(ownerFiltersWithRepos[ownerFilterWithRepo].repos, true)))
        .map(owner => owner.toLowerCase()));
    return {
        allExistingOwners,
        allForcedOwners,
        allForcedRepos,
        allIncludedOwners,
        allIncludedRepos,
        ownerFilterIsStrict,
        ownerFilters,
        ownerFiltersWithRepos,
        repoFilterIsStrict,
        repoFilters,
    };
}
exports.getOwnerAndRepoFormattedFilter = getOwnerAndRepoFormattedFilter;
function itemPassesOwnerOrRepoFilter(type, item, ownerAndRepoFormattedFilter) {
    const { ownerFilterIsStrict, ownerFilters, ownerFiltersWithRepos, repoFilterIsStrict, repoFilters, } = ownerAndRepoFormattedFilter;
    if (ownerFilters &&
        ownerFiltersWithRepos &&
        repoFilters &&
        !github_1.getItemOwnersAndRepos(type, item).every(or => {
            const thisOwnerRepoFilters = ownerFiltersWithRepos &&
                ownerFiltersWithRepos[or.owner] &&
                ownerFiltersWithRepos[or.owner].repos;
            const thisOwnerRepoFilterIsStrict = thisOwnerRepoFilters &&
                exports.filterRecordWithThisValueCount(thisOwnerRepoFilters, true);
            const ownerIsChecked = ownerFilters[or.owner] === true ||
                (ownerFilters[or.owner] !== false &&
                    ((!ownerFilterIsStrict && !repoFilterIsStrict) ||
                        thisOwnerRepoFilterIsStrict));
            if (!ownerIsChecked)
                return false;
            if (!thisOwnerRepoFilters)
                return true;
            const repoIsChecked = thisOwnerRepoFilters[or.repo] === true ||
                (thisOwnerRepoFilters[or.repo] !== false &&
                    !thisOwnerRepoFilterIsStrict);
            return !!repoIsChecked;
        }))
        return false;
    return true;
}
exports.itemPassesOwnerOrRepoFilter = itemPassesOwnerOrRepoFilter;
function itemPassesStringSearchFilter(type, item, query, { dashboardFromUsername, shouldSkip, }) {
    const itemStrings = github_1.getItemSearchableStrings(type, item, {
        dashboardFromUsername,
    });
    const termsToSearchFor = shared_1.getSearchQueryTerms(query);
    if (!(termsToSearchFor && termsToSearchFor.length))
        return true;
    if (!(itemStrings && itemStrings.length))
        return true;
    return termsToSearchFor.every(termArr => {
        if (!(termArr &&
            Array.isArray(termArr) &&
            (termArr.length === 2 || termArr.length === 3)))
            return true;
        const [key, _value, isNegated] = termArr.length === 2 ? ['', termArr[0], termArr[1]] : termArr;
        const value = _value && _value[0] === '"' && _value.slice(-1) === '"'
            ? _value.slice(1, -1).trim()
            : _value;
        if (!value)
            return false;
        if (shouldSkip && shouldSkip({ key, value, isNegated }))
            return true;
        const searchTerms = key
            ? [`${key}:${value}`, `${key}:"${value}"`]
            : [value, `"${value}"`];
        const found = itemStrings.some(itemString => {
            if (!(itemString && typeof itemString === 'string'))
                return false;
            return searchTerms.some(searchTerm => itemString.toLowerCase().includes(searchTerm.toLowerCase()));
        });
        return isNegated ? !found : found;
    });
}
exports.itemPassesStringSearchFilter = itemPassesStringSearchFilter;
function baseColumnHasAnyFilter(filters) {
    if (!filters)
        return false;
    if (filters.clearedAt)
        return true;
    if (typeof filters.bot === 'boolean')
        return true;
    if (typeof filters.draft === 'boolean')
        return true;
    if (typeof filters.private === 'boolean')
        return true;
    if (typeof filters.saved === 'boolean')
        return true;
    if (typeof filters.unread === 'boolean')
        return true;
    if (filters.query)
        return true;
    if (filters.state && exports.filterRecordHasAnyForcedValue(filters.state)) {
        return true;
    }
    if (filters.subjectTypes &&
        exports.filterRecordHasAnyForcedValue(filters.subjectTypes)) {
        return true;
    }
    const { ownerFilters, repoFilters } = getOwnerAndRepoFormattedFilter(filters);
    if (ownerFilters && exports.filterRecordHasAnyForcedValue(ownerFilters)) {
        return true;
    }
    if (repoFilters && exports.filterRecordHasAnyForcedValue(repoFilters)) {
        return true;
    }
    return false;
}
function columnHasAnyFilter(type, filters) {
    if (!filters)
        return false;
    if (baseColumnHasAnyFilter(filters))
        return true;
    if (type === 'activity') {
        const f = filters;
        if (f.activity && exports.filterRecordHasAnyForcedValue(f.activity.actions)) {
            return true;
        }
        if (exports.filterRecordHasAnyForcedValue(f.watching)) {
            return true;
        }
    }
    if (type === 'notifications') {
        const f = filters;
        if (f.notifications && f.notifications.participating) {
            return true;
        }
        if (f.notifications &&
            exports.filterRecordHasAnyForcedValue(f.notifications.reasons)) {
            return true;
        }
    }
    return false;
}
exports.columnHasAnyFilter = columnHasAnyFilter;
function getFilteredIssueOrPullRequests(items, filters, { dashboardFromUsername, }) {
    let _items = github_1.sortIssuesOrPullRequests(items);
    const ownerAndRepoFormattedFilter = getOwnerAndRepoFormattedFilter(filters);
    if (filters && columnHasAnyFilter('issue_or_pr', filters)) {
        _items = _items.filter(item => {
            if (!item)
                return;
            const subjectType = github_1.getIssueOrPullRequestSubjectType(item);
            const issueOrPR = github_1.getItemIssueOrPullRequest('issue_or_pr', item);
            if (!itemPassesOwnerOrRepoFilter('issue_or_pr', item, ownerAndRepoFormattedFilter))
                return false;
            // we will filter only some things locally as an optimistic update (e.g. labels),
            // but all other text filter will be handled by github only,
            // since they consider more data like all comment content, etc
            if (!itemPassesStringSearchFilter('issue_or_pr', item, filters.query, {
                dashboardFromUsername,
                shouldSkip: ({ key, value }) => !(key === 'label' || (!key && value && value.match(/^#([0-9]+)$/))),
            }))
                return false;
            const isStateFilterStrict = exports.filterRecordWithThisValueCount(filters.state, true);
            if ((isStateFilterStrict &&
                (!issueOrPR ||
                    !itemPassesFilterRecord(filters.state, github_1.getIssueOrPullRequestState(issueOrPR), true))) ||
                (!isStateFilterStrict &&
                    issueOrPR &&
                    !itemPassesFilterRecord(filters.state, github_1.getIssueOrPullRequestState(issueOrPR), true)))
                return false;
            if (typeof filters.bot === 'boolean' &&
                filters.bot !==
                    github_1.getItemIsBot('issue_or_pr', item, { considerProfileBotsAsBots: true }))
                return false;
            if ((filters.draft === true &&
                (!issueOrPR || filters.draft !== github_1.isDraft(issueOrPR))) ||
                (filters.draft === false &&
                    issueOrPR &&
                    filters.draft !== github_1.isDraft(issueOrPR)))
                return false;
            if (!itemPassesFilterRecord(filters.subjectTypes, subjectType, true))
                return false;
            if (typeof filters.unread === 'boolean' &&
                filters.unread !== !github_1.isItemRead(item)) {
                return false;
            }
            const showSaveForLater = filters.saved !== false;
            const showInbox = filters.saved !== true;
            const showCleared = false;
            if (filters.clearedAt &&
                (!item.updated_at ||
                    new Date(item.updated_at).getTime() <=
                        new Date(filters.clearedAt).getTime() ||
                    new Date(item.updated_at).getTime() > Date.now()))
                if (!(showSaveForLater && github_1.isItemSaved(item)))
                    /* && isItemRead(notification) */
                    return showCleared;
            if (github_1.isItemSaved(item))
                return showSaveForLater;
            return showInbox;
        });
    }
    return _items;
}
exports.getFilteredIssueOrPullRequests = getFilteredIssueOrPullRequests;
function getFilteredNotifications(notifications, filters, { dashboardFromUsername, }) {
    let _notifications = github_1.sortNotifications(notifications);
    const reasonsFilter = filters && filters.notifications && filters.notifications.reasons;
    const ownerAndRepoFormattedFilter = getOwnerAndRepoFormattedFilter(filters);
    if (filters && columnHasAnyFilter('notifications', filters)) {
        _notifications = _notifications.filter(item => {
            if (!item)
                return;
            const subjectType = github_1.getNotificationSubjectType(item);
            const issueOrPR = github_1.getItemIssueOrPullRequest('notifications', item);
            if (!itemPassesFilterRecord(reasonsFilter, item.reason, true))
                return false;
            if (!itemPassesOwnerOrRepoFilter('notifications', item, ownerAndRepoFormattedFilter))
                return false;
            if (!itemPassesStringSearchFilter('notifications', item, filters.query, {
                dashboardFromUsername,
            }))
                return false;
            if (filters.notifications &&
                filters.notifications.participating &&
                (item.reason === 'subscribed' || item.reason === 'security_alert'))
                return false;
            const isStateFilterStrict = exports.filterRecordWithThisValueCount(filters.state, true);
            if ((isStateFilterStrict &&
                (!issueOrPR ||
                    !itemPassesFilterRecord(filters.state, github_1.getIssueOrPullRequestState(issueOrPR), true))) ||
                (!isStateFilterStrict &&
                    issueOrPR &&
                    !itemPassesFilterRecord(filters.state, github_1.getIssueOrPullRequestState(issueOrPR), true)))
                return false;
            if (typeof filters.bot === 'boolean' &&
                filters.bot !==
                    github_1.getItemIsBot('notifications', item, {
                        considerProfileBotsAsBots: true,
                    }))
                return false;
            if ((filters.draft === true &&
                (!issueOrPR || filters.draft !== github_1.isDraft(issueOrPR))) ||
                (filters.draft === false &&
                    issueOrPR &&
                    filters.draft !== github_1.isDraft(issueOrPR)))
                return false;
            if (!itemPassesFilterRecord(filters.subjectTypes, subjectType, true))
                return false;
            if (typeof filters.unread === 'boolean' &&
                filters.unread !== !github_1.isItemRead(item)) {
                return false;
            }
            if (typeof filters.private === 'boolean' &&
                shared_1.isNotificationPrivate(item) !== filters.private) {
                return false;
            }
            const showSaveForLater = filters.saved !== false;
            const showInbox = filters.saved !== true;
            const showCleared = false;
            if (filters.clearedAt &&
                (!item.updated_at ||
                    new Date(item.updated_at).getTime() <=
                        new Date(filters.clearedAt).getTime() ||
                    new Date(item.updated_at).getTime() > Date.now()))
                if (!(showSaveForLater && github_1.isItemSaved(item)))
                    /* && isItemRead(notification) */
                    return showCleared;
            if (github_1.isItemSaved(item))
                return showSaveForLater;
            return showInbox;
        });
    }
    return _notifications;
}
exports.getFilteredNotifications = getFilteredNotifications;
function getFilteredEvents(events, filters, { dashboardFromUsername, mergeSimilar, }) {
    let _events = events_1.sortEvents(events);
    if (!(_events && _events.length))
        return utils_1.constants.EMPTY_ARRAY;
    const actionFilter = filters && filters.activity && filters.activity.actions;
    const ownerAndRepoFormattedFilter = getOwnerAndRepoFormattedFilter(filters);
    if (filters && columnHasAnyFilter('activity', filters)) {
        _events = _events.filter(item => {
            if (!item)
                return;
            const subjectType = events_1.getEventMetadata(item).subjectType;
            const issueOrPR = github_1.getItemIssueOrPullRequest('activity', item);
            if (!itemPassesOwnerOrRepoFilter('activity', item, ownerAndRepoFormattedFilter))
                return false;
            if (!itemPassesFilterRecord(filters.watching || {}, `${events_1.getEventWatchingOwner(item, { dashboardFromUsername }) ||
                ''}`.toLowerCase(), true))
                return false;
            if (!itemPassesStringSearchFilter('activity', item, filters.query, {
                dashboardFromUsername,
            }))
                return false;
            const isStateFilterStrict = exports.filterRecordWithThisValueCount(filters.state, true);
            if ((isStateFilterStrict &&
                (!issueOrPR ||
                    !itemPassesFilterRecord(filters.state, github_1.getIssueOrPullRequestState(issueOrPR), true))) ||
                (!isStateFilterStrict &&
                    issueOrPR &&
                    !itemPassesFilterRecord(filters.state, github_1.getIssueOrPullRequestState(issueOrPR), true)))
                return false;
            if (typeof filters.bot === 'boolean' &&
                filters.bot !==
                    github_1.getItemIsBot('activity', item, { considerProfileBotsAsBots: true }))
                return false;
            if ((filters.draft === true &&
                (!issueOrPR || filters.draft !== github_1.isDraft(issueOrPR))) ||
                (filters.draft === false &&
                    issueOrPR &&
                    filters.draft !== github_1.isDraft(issueOrPR)))
                return false;
            if (!itemPassesFilterRecord(filters.subjectTypes, subjectType, true))
                return false;
            if (!itemPassesFilterRecord(actionFilter, events_1.getEventMetadata(item).action, true))
                return false;
            if (typeof filters.unread === 'boolean' &&
                filters.unread !== !github_1.isItemRead(item)) {
                return false;
            }
            if (typeof filters.private === 'boolean' &&
                shared_1.isEventPrivate(item) !== filters.private) {
                return false;
            }
            const showSaveForLater = filters.saved !== false;
            const showInbox = filters.saved !== true;
            const showCleared = false;
            if (filters.clearedAt &&
                (!item.created_at ||
                    new Date(item.created_at).getTime() <=
                        new Date(filters.clearedAt).getTime() ||
                    new Date(item.created_at).getTime() > Date.now()))
                if (!(showSaveForLater && github_1.isItemSaved(item)))
                    /* && isItemRead(event) */
                    return showCleared;
            if (github_1.isItemSaved(item))
                return showSaveForLater;
            return showInbox;
        });
    }
    return mergeSimilar ? events_1.mergeSimilarEvents(_events, exports.mergeMaxLength) : _events;
}
exports.getFilteredEvents = getFilteredEvents;
exports.mergeMaxLength = 5;
//# sourceMappingURL=filters.js.map